import { render, staticRenderFns } from "./iframeCom.vue?vue&type=template&id=52a63904&"
import script from "./iframeCom.vue?vue&type=script&lang=js&"
export * from "./iframeCom.vue?vue&type=script&lang=js&"
import style0 from "./iframeCom.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports